/**
 * Extract YouTube video ID from various YouTube URL formats
 */
export const getYouTubeVideoId = (url: string): string | null => {
  // Extract just the URL part (first whitespace-separated token) to handle trailing text
  const cleanUrl = url.trim().split(/\s+/)[0]

  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?\s]*).*/
  const match = cleanUrl.match(regExp)
  return match && match[7].length === 11 ? match[7] : null
}
